import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  SEND_RESET_CODE_REQUEST,
  VERIFY_RESET_CODE_REQUEST,
  RESET_USER,
} from "./actionTypes";
import {
  sendResetCodeSuccess,
  sendResetCodeFailure,
  verifyResetCodeSuccess,
  verifyResetCodeFailure,
  resetUserSuccessful,
  resetUserFailed,
} from "./actions";

import {
  verifyResetEmail,
  verifyResetSessionCode,
  setResetPassword,
} from "../../../helpers/backend-helper";

function* sendResetCode({ payload: { email } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const res = yield call(verifyResetEmail, { email });
      yield put(sendResetCodeSuccess(email, res.message));
    } else {
      yield put(sendResetCodeSuccess(email, "Code sent (fake). Use 123456"));
    }
  } catch (error) {
    yield put(sendResetCodeFailure(error.response?.data?.message || error.message || error));
  }
}

function* verifyResetCode({ payload: { email, code } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const res = yield call(verifyResetSessionCode, { email, code });
      yield put(verifyResetCodeSuccess(res.email, res.message));
    } else {
      if (code === "123456") {
        yield put(verifyResetCodeSuccess(null, "Verified (fake)"));
      } else {
        throw new Error("Invalid verification code");
      }
    }
  } catch (error) {
    yield put(verifyResetCodeFailure(error.response?.data?.message || error.message || error));
  }
}

function* resetUser({ payload: { email, code, newPassword, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const res = yield call(setResetPassword, { email, code, newPassword });
      yield put(resetUserSuccessful(res));
      if (history) history("/signin");
    }
  } catch (error) {
    yield put(resetUserFailed(error.response?.data?.message || error.message || error));
  }
}

function* watchSendCode() {
  yield takeEvery(SEND_RESET_CODE_REQUEST, sendResetCode);
}
function* watchVerifyCode() {
  yield takeEvery(VERIFY_RESET_CODE_REQUEST, verifyResetCode);
}
function* watchUserReset() {
  yield takeEvery(RESET_USER, resetUser);
}

export default function* accountSaga() {
  yield all([fork(watchSendCode), fork(watchVerifyCode), fork(watchUserReset)]);
}
